import React, { useState, useEffect } from 'react';
import { Table, Typography, Tag, Spin, message, Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Title } = Typography;

const ExamHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        console.log('开始获取考试历史');
        const res = await axios.get('/api/exams/history');
        console.log('获取到考试历史数据:', res.data);
        setHistory(Array.isArray(res.data) ? res.data : []);
        setError(null);
      } catch (err) {
        console.error('获取考试历史失败:', err);
        setError(err.message || '获取数据失败');
        message.error('获取考试历史失败，请稍后再试');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  // 如果出错显示错误状态
  if (error) {
    return (
      <Result
        status="error"
        title="获取考试历史失败"
        subTitle={error}
        extra={[
          <Button type="primary" key="retry" onClick={() => window.location.reload()}>
            重试
          </Button>,
          <Button key="back" onClick={() => navigate('/selection')}>
            返回考试中心
          </Button>,
        ]}
      />
    );
  }

  const columns = [
    {
      title: '考试类别',
      dataIndex: 'professionalCategory',
      key: 'professionalCategory',
    },
    {
      title: '考试时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => text ? new Date(text).toLocaleString() : '未知',
    },
    {
      title: '得分',
      dataIndex: 'totalScore',
      key: 'totalScore',
      render: (text) => text !== undefined && text !== null ? `${text}分` : '未完成',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        if (text === '通过') return <Tag color="green">通过</Tag>;
        if (text === '未通过') return <Tag color="red">未通过</Tag>;
        return <Tag color="blue">未完成</Tag>;
      },
    },
  ];

  return (
    <div style={{ padding: '20px' }}>
      <Title level={2}>考试历史</Title>
      {loading ? (
        <div style={{ textAlign: 'center', margin: '50px 0' }}>
          <Spin size="large" />
          <p>加载考试历史数据...</p>
        </div>
      ) : (
        <>
          <Table 
            dataSource={history} 
            columns={columns} 
            rowKey={(record) => record._id || Math.random().toString()}
            pagination={false}
            locale={{ emptyText: '暂无考试记录' }}
          />
          <div style={{ marginTop: '20px', textAlign: 'center' }}>
            <Button type="primary" onClick={() => navigate('/selection')}>
              返回考试中心
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default ExamHistory; 